import { createAction, props } from '@ngrx/store';
import { IUserConfiguration } from './user.reducer';

export const loadUserConfiguration = createAction(
  '[User ] Load'
);

export const loadUserConfigurationSuccess = createAction(
  '[User ] Load Success',
  props<{ user: IUserConfiguration }>()
);

export const loadUserConfigurationFailure = createAction(
  '[User ] Load Failure',
  props<{ error: any }>()
);


export const loadUserConfigurationOverwrite = createAction(
  '[User ] Load Overwrite',
  props<{ user: IUserConfiguration }>()
);
